export const baseURL = process.env.REACT_APP_BASE_URL;
export const env = process.env.REACT_APP_ENV;
export const wssURL = process.env.REACT_APP_WSS_URL;
export const googleMapApiKey = process.env.REACT_APP_KEY_GOOGLE_MAP;

// Ring Central
export const ringCentralEmbeddableUrl = process.env.REACT_APP_RC_EMBEDDABLE_URL;
export const ringCentralClientId = process.env.REACT_APP_RC_APP_CLIENT_ID;
export const ringCentralServer = process.env.REACT_APP_RC_SERVER_URL;
export const ringCentralClientSecret = process.env.REACT_APP_RC_APP_CLIENT_SECRET;

// Payment
export const paymentSrc = process.env.REACT_APP_PAYMENT_SRC;
export const paymentApiLoginId = process.env.REACT_APP_PAYMENT_API_LOGIN_ID;
export const paymentClientKey = process.env.REACT_APP_PAYMENT_CLIENT_KEY;
